/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import { Button, Form, Input, InputNumber, message, Modal } from "antd";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class SelfServiceTexts extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalCreateEdit: null,
        };

        this.id = "SELF_SERVICE_TEXTS";

        this.api = {
            get: "get_self_service_texts",
            create: "create_self_service_texts",
            edit: "edit_self_service_texts",
            delete: "delete_self_service_texts",
            check: "check_self_service_texts",
        }

        this.selectors = [
            { id: "SELF_SERVICE_LANGS_LIST", api: "self_service_langs_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach((x) => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21718);
    }

    renderEdit = (text, record) => {
        let gt = this.getText;
        return (<TableLineIcons
            onEdit={() => { this.setState({ modalCreateEdit: record }) }}
            onDelete={() => { this.props.dataActions.genericDataDeleteRow(this.id, record.key, this.props.user.companyCode, this.props.user.token, this.api.delete, this.api.get) }}
            deleteQuetion={{ title: gt(21725), okText: gt(21726), cancelText: gt(21727) }}
        />)
    }

    handleOk = () => {
        const data = this.state.modalCreateEdit
        const gt = this.getText
        const saveRow = d => {
            this.sendAPI(d.tID == 0 ? this.api.create : this.api.edit, d, () => {
                message.success(gt(21731))
                this.setState({ modalCreateEdit: null }, () => {
                    this.props.dataActions.genericDataGetRequested(this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
                })
            })
        }

        if (data.tID == 0) {
            this.sendAPI(this.api.check, data, (ob) => {
                if (ob.data) {
                    const [_id, _text] = ob.data.split("\f")
                    Modal.confirm({
                        content: (<>
                            <h4>{gt(21732)} {data.tTextCode} {gt(21733)} {data.tLangName} {gt(21734)} {data.tPosName} {gt(21735)} {_text}</h4>
                            <h4>{gt(21736)}</h4>
                        </>),
                        iconType: 'exclamation-circle',
                        okText: gt(21737),
                        cancelText: gt(21738),
                        onOk: () => { saveRow({ ...data, tID: _id }) },
                        onCancel() { },
                    })
                } else {
                    saveRow(data)
                }
            })
        } else {
            saveRow(data)
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let sorter = true;
        let render = t => t;

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(21718)}
                addButton={() => {
                    this.setState({
                        modalCreateEdit: {
                            tID: 0,
                            tLangCode: null,
                            tLangName: null,
                            tLangFlag: null,
                            tTextCode: null,
                            tDesc: null,
                            tText: null,
                            tPosID: null,
                            tPosName: null,
                        }
                    })
                }}
                searchBox
                columns={[
                    { title: gt(21719), key: "tLangCode", dataIndex: "tLangCode", width: "15%", sorter, render: (t, r) => `${t} - ${r.tLangName}` },
                    { title: gt(21720), key: "tTextCode", dataIndex: "tTextCode", width: "10%", sorter, render },
                    { title: gt(21721), key: "tDesc", dataIndex: "tDesc", width: "30%", sorter, render },
                    { title: gt(21722), key: "tText", dataIndex: "tText", width: "20%", sorter, render },
                    { title: gt(21723), key: "tPosID", dataIndex: "tPosID", width: "15%", sorter, render: (t, r) => `${t} - ${r.tPosName}` },
                    { title: gt(21724), width: "10%", sorter, render: this.renderEdit },
                ]}
            />
            <GenericModal
                visible={this.state.modalCreateEdit != null}
                onCancel={() => { this.setState({ modalCreateEdit: null }) }}
                title={gt(21728)}
                width={600}
                footer={[
                    <Button key="back" style={{ marginLeft: 5 }} onClick={() => { this.setState({ modalCreateEdit: null }) }}>{gt(21730)}</Button>,
                    <Button key="create" type="primary" onClick={this.handleOk}>{gt(21729)}</Button>,
                ]}
            >
                <Form.Item label={gt(21719)}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[0]}
                        value={this.state.modalCreateEdit?.tLangCode}
                        onChange={() => { }}
                        onChangeGetDetailed={(e) => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tLangCode: e.code, tLangName: e.name } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21720)}>
                    <InputNumber
                        style={{ width: 150 }}
                        value={this.state.modalCreateEdit?.tTextCode}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tTextCode: e } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21722)}>
                    <Input
                        value={this.state.modalCreateEdit?.tText}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tText: e.target.value } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21721)}>
                    <Input.TextArea
                        value={this.state.modalCreateEdit?.tDesc}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tDesc: e.target.value } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21723)}>
                    <GenericSelectorPosStorages
                        {...this.props}
                        value={this.state.modalCreateEdit?.tPosID}
                        onChange={() => { }}
                        onChangeGetDetailed={(e) => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tPosID: e.code, tPosName: e.name } }) }}
                    />
                </Form.Item>
            </GenericModal>
        </div>)
    }

}

export default SelfServiceTexts;